import { OrderLine } from '@models/order';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';

function useCartItems() {
    const { orderLines } = useCalculatedCart();
    const enableItems = orderLines.filter((orderLine) => orderLine.status !== 'SOLD_OUT');
    const soldOutItems = orderLines.filter((orderLine) => orderLine.status === 'SOLD_OUT');

    const enableItemQty = enableItems
        .filter((item) => item.status === 'ON_SALE')
        .reduce((acc, cur) => acc + cur.quantity, 0);
    const soldOutItemQty = soldOutItems
        .reduce((acc, cur) => acc + cur.quantity, 0);

    const sortedEnableItems = sortByCartItemId(enableItems);
    const sortedSoldOutItems = sortByCartItemId(soldOutItems);
    const isSoldOutItemBlank = sortedSoldOutItems.length === 0;

    return {
        enableItemQty,
        soldOutItemQty,
        sortedEnableItems,
        sortedSoldOutItems,
        isSoldOutItemBlank,
    };
}

function sortByCartItemId(orderLine: OrderLine[]) {
    return orderLine.sort(
        (a, b) => b.cartItemId?.localeCompare(a?.cartItemId || '') || 0,
    );
}

export default useCartItems;
